import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './reducers';
import thunk from 'redux-thunk';


//checking every dispatch in redux dev-tools

const logger = store=>{
    return next => {
        return action=>{
            // console.log("Middleware:Dispatching", action);
            const result = next(action);
            // console.log("Middleware.Next State", store.getState());
            return result;
        }
    }
}

//this is for redux chrome extension 
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(logger, thunk)));
// const store = createStore(composeEnhancers(applyMiddleware(logger, thunk)));

export default store;
